export default "/_next/static/images/apple-touch-icon-iphone-be3de2f851d4d4898605c0a93d2e8f35.png";